import { isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'

import AttackMetricsChart from 'components/attacks/details/AttackMetricsChart'
import { isAttackInCompleteState } from 'components/attacks/utils/attack-stages'
import useAgent from 'hooks/use-agent'
import useAuth from 'hooks/use-auth'
import useMetadata from 'hooks/use-metadata'
import { METRICS_STATE, shouldMetricsPoll } from 'utils/attack-metrics'
import { getMetaForDisplayableArgs, getArgByKey } from 'utils/metadata'
import { percentToDecimal } from 'utils/numbers'

export default function AdhocAttackMetrics({ attack, darkMode, ...rest }) {
  const { currentTeamId } = useAuth()
  const { metadata } = useMetadata()
  const [isMetringsPollingEnabled, setIsMetringsPollingEnabled] = useState(
    !isAttackInCompleteState(attack)
  )

  const { data: metricsWithMeta, isLoading } = useAgent(
    `/metrics/attacks/${attack.guid}?teamId=${currentTeamId}`,
    { state: METRICS_STATE.NOT_LOADED, metric_data: {} },
    {
      interval: isMetringsPollingEnabled ? 5000 : false,
      shouldCache: true
    }
  )

  // Stop polling for the attack data if its in completed stage
  useEffect(() => {
    if (isMetringsPollingEnabled && !shouldMetricsPoll(metricsWithMeta)) {
      setIsMetringsPollingEnabled(false)
    }
  }, [metricsWithMeta, isMetringsPollingEnabled])

  const arg = !isEmpty(attack?.infra_command?.commandArgs?.cliArgs)
    ? getArgByKey(
        'percent',
        getMetaForDisplayableArgs(
          attack?.infra_command?.commandArgs?.cliArgs,
          metadata
        )
      )
    : { value: attack?.infra_command?.commandArgs.percent }

  return metricsWithMeta.state === METRICS_STATE.DISABLED ? null : (
    <AttackMetricsChart
      isAdhocAttack
      attackType={attack?.infra_command?.commandType}
      darkMode={darkMode}
      isLoadingData={isLoading}
      magnitude={percentToDecimal(arg?.value ?? 100, 2)}
      metricsWithMeta={metricsWithMeta}
      wasHalted={attack?.stage === 'UserHalted'}
      {...rest}
    />
  )
}

AdhocAttackMetrics.propTypes = {
  attack: PropTypes.object,
  darkMode: PropTypes.bool
}
